<div class='d-flex flex-column p-3'>
  <h4 style='text-align: center;'>HATTRIX END USER TERMS OF SERVICE</h4>
  <p lang='en-US' style='text-align: center;'>
    Last Modified: March 14, 2024
  </p>
  <ol>
    <li>
      <p lang='en-US'>
        <strong>Your Acceptance</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Welcome to the Hattrix End User Terms of Service. This is an agreement
    (“Agreement”) between Hattrix, LLC (“Hattrix”) the operator of the website
    <a href='https://www.retreva.com/'>www.retreva.com</a>, the Retreva and
    Hattrix branded applications and software, components, and any associated
    services offered (collectively the “Platform”) and you (“you”, “your”, or
    “End User”) an End User of the Platform.
  </p>
  <p lang='en-US'>
    PLEASE BE AWARE THAT THERE ARE CLASS ACTION, JURY WAIVER, ARBITRATION, AND
    PAGA PROVISIONS CONTAINED IN THIS AGREEMENT.
  </p>
  <p lang='en-US'>
    Throughout this Agreement, the words “Hattrix,” “us,” “we,” and “our,” refer
    to our company, Hattrix, as is appropriate in the context of the use of the
    words.
  </p>
  <p lang='en-US'>
    By clicking “I agree”, subscribing to the Platform, or accessing or using
    the Platform you agree to be bound by this Agreement and the Privacy Policy.
    We may amend our Agreement or the Privacy Policy and may notify you when we
    do so. If you do not agree with any changes, please cease using our Platform
    immediately.
  </p>
  <ol start='2'>
    <li>
      <p lang='en-US'>
        <strong>Access and Registration</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    <a name='_Hlk136607980'></a> End Users may access the Platform as permitted
    by us. Where required, End Users must register on the Platform before
    accessing portions of the Platform. During registration, your information
    will be collected and disclosed in accordance with our Privacy Policy. You
    are required to provide truthful, up-to-date, and accurate information when
    registering for our Platform and you must be over the age of 18 to register
    and create an account. We reserve the right to verify all End User
    credentials and to reject any End Users. Further we may request additional
    information or perform a background check prior to activating your account.
    We reserve the right to deny or restrict your account at our discretion. You
    are entirely responsible for maintaining the confidentiality of your
    password, account, and for any and all activities that occur under your
    account. You agree to notify Hattrix immediately of any unauthorized use of
    your account or any other breach of security. Hattrix will not be liable for
    any losses you incur as a result of someone else using your password or
    account, either with or without your knowledge. Each End User is only
    entitled to one account and End Users may not share accounts with any third
    parties. If you are creating an account on behalf of an organization you
    agree that you have the authority to bind such organization and your
    organization shall be responsible for each authorized End User’s use of the
    Platform.
  </p>
  <ol start='3'>
    <li>
      <p lang='en-US'>
        <strong>End User Responsibilities</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    End User represents, warrants, and covenants that: (1) End User shall use
    the Platform solely for End User’s internal commercial purposes in
    accordance with this Agreement; (2) the person entering into this Agreement
    on behalf of End User is duly authorized and has the power and authority to
    enter into this Agreement and bind End User; (3) any End User Content
    distributed via the Platform shall be professional, lawful, accurate, and
    up-to-date; (4) any End User Content posted on the Platform by End User does
    not violate any third party agreements; and (5) End User shall use the
    Platform only for legal and lawful purposes and agrees to abide by all laws
    of its local jurisdiction and all US laws when using the Platform including
    but not limited to laws relating to data privacy, spam, marketing, and
    email. End User shall indemnify and hold Hattrix harmless for a breach of
    any provisions of this section. Where you have violated this Agreement we
    reserve the right to release your information to law enforcement in order to
    assist with any investigation at our discretion. Where required, End User
    shall clearly post a privacy policy (in compliance with the laws of End
    User’s local jurisdiction) prior to collecting any information and shall
    disclose to its Customers (defined below) how such personal information may
    be shared with third parties and allow Customers to opt out where
    applicable. Where required by local applicable law End User shall ensure
    that its Customers have opted in to receive communications from End User and
    shall provide evidence of such opt ins as requested by Hattrix.
  </p>
  <ol start='4'>
    <li>
      <p lang='en-US'>
        <strong>Platform Ownership</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    In accordance with this Agreement, we may provide you access to the Platform
    after registration along with payment as applicable. The Platform is sold as
    a licensed subscription (“Subscription”) and your Subscription does not
    entitle you to any ownership of the Platform. You merely receive a
    non-exclusive, limited, non-assignable, and fully revocable right to access
    the Platform at our discretion. Where you download any portion of our
    Platform, we grant you a non-exclusive, limited, non-assignable, and fully
    revocable license to download and use one such copy. You acknowledge that
    the structure, organization, and code of the Platform, any hosted services,
    and all related software components are proprietary to Hattrix and/or
    Hattrix’ licensors and that Hattrix and/or its licensors retains exclusive
    ownership of the Platform, any documentation, information and any and all
    other intellectual property rights relating to the Platform, including all
    modifications, copies, enhancements, derivatives, and other software and
    materials developed hereunder by Hattrix. You shall not remove any
    proprietary, copyright, trademark, or service mark legend from any portion
    of any of the Platform, including any modifications, enhancements,
    derivatives, and other software and materials developed by Hattrix. All
    rights not expressly granted in this Agreement are reserved for us. You may
    only access the Platform as permitted by us and please be aware that we are
    not responsible for any End User Content (defined below) encountered on the
    Platform. Please be aware that all portions of the Platform are offered on
    an “as is” basis and Hattrix makes no representations or warranties
    regarding any portion of the Platform. Hattrix reserves the right to modify,
    change, and/or discontinue any and all portions of the Platform at any time
    and may also remove or add features or functionality to any subscription
    levels at its sole discretion. Nothing in this Agreement obligates Hattrix
    to make any previously available feature on the Platform available to
    Subscriber or offer any types of compatibility or versioning.
  </p>
  <ol start='5'>
    <li>
      <p lang='en-US'>
        <strong>Privacy Practices</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    End User represents, warrant, and covenants that: (1) where it collects
    electronic information from its Customer, it will prominently display its
    privacy policy (that is in full compliance with US and applicable laws) in a
    manner that is easily accessible to its Customers (defined below); (2) shall
    receive informed consent from its Customers where required. Additionally,
    the End User’s privacy policy shall provide its Customers with a mechanism
    to opt out of such collection and information usage.
  </p>
  <ol start='6'>
    <li>
      <p lang='en-US'>
        <strong>Consumer Communications</strong>
      </p>
    </li>
  </ol>
  <p>
    <a name='_Hlk104391654'></a> The Platform may allow End User to submit End
    User Content to create Customer communications for marketing or other
    purposes (collectively “Consumer Communication(s)”). End Users are solely
    responsible for any Consumer Communications created. If any Consumer
    Communications are in violation of any agreement or applicable law or
    regulation, you agree to indemnify and hold us harmless from any claim
    related to such personal information, including but not limited to the costs
    of responding to such claim and/or the costs of suit, fine or other
    sanction. All such Consumer Communications generated shall be solely owned
    by End User and subject to the End User rights and license as set forth
    below within the End User Content section of this Agreement. End User agrees
    that End User will not do the following with any Consumer Communications
    generated: (i) permit any third party to access or use the Consumer
    Communications; (ii) publish, copy, distribute, sublicense, sell, disclose,
    lend, or transfer any Consumer Communications externally, (iii) reverse
    engineer, attempt to re-identify or extract or recover any code or software
    used to generate such Consumer Communications; (iv) use the Consumer
    Communications in a manner that is unlawful; or (v) to transmit viruses or
    worms . You represent, warrant, and covenant that your collection, storage,
    and use of any Consumer Communications shall be in compliance with all
    applicable laws and regulations including but not limited to United States’
    federal and state consumer and data privacy laws. Hattrix retains all right,
    title and interest in and to the Platform including but not limited to any
    Hattrix underlying technology used to generate the Consumer Communications,
    general techniques, methods, processes, routines, tools, concepts,
    inventions, patterns, algorithms, techniques and know-how developed previous
    to or during the provision of the services (collectively “Underlying
    Technology”) provided by Hattrix to End User under this Agreement via the
    Platform. Except where stated otherwise, anything developed or delivered by
    or on behalf of Hattrix under this Agreement is owned exclusively by Hattrix
    or its licensors including all Underlying Technology. The rights granted to
    End Users do not convey any rights in the Platform, express or implied, or
    ownership in the Platform or any Hattrix Underlying Technology. End User
    shall not remove any proprietary, copyright, trademark, or service mark
    legend from any portion of any of the Platform, including any modifications,
    enhancements, derivatives, and other software and materials developed by
    Hattrix. Where any Underlying Technology is incorporated into any Consumer
    Communications Hattrix grants End User a revocable, limited, non-assignable,
    non-transferable license to use the Underlying Technology solely for the
    purposes of accessing such Consumer Communications. Such license is
    conditioned on compliance with this Agreement and timely payment of all fees
    required to access such Consumer Communications.
  </p>
  <ol start='7'>
    <li>
      <p lang='en-US'>
        <strong>TCPA and Can-Spam</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    <a name='_Hlk130305304'></a> You represent, covenant, and warrant to abide
    by all relevant laws including but no limited to Telephone Consumer
    Protection Act 47 USC § 227 (“TCPA”) and the Controlling the Assault of
    Non-Solicited Pornography And Marketing of 2003 (“Can-Spam”) when using the
    Platform or when using information derived from the Platform to send
    Consumer Communications. As required by Can-Spam and TCPA you agree to do
    the following: (i) maintain opt out lists and remove End Users who do not
    wish to receive further communications; (ii) collect opt ins and consents
    where required; (iii) promptly respond to any complaints regarding TCPA or
    Can-Spam by End Users of the Platform; (iv) any communications must contain
    and unsubscribe option located within the communication itself. Where we
    believe in our discretion that you have not complied with this Section we
    may suspend your access to the Platform or your ability to send
    communications immediately or at any time. You shall fully indemnify and
    hold harmless Hattrix for all claims related to TCPA and Can-Spam whether
    made by a third party or us.
  </p>
  <ol start='8'>
    <li>
      <p lang='en-US'>
        <strong>End User’s Customers</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Please be aware that End User is solely responsible for any interactions
    with any customers (“Customers”). THE END USER AGREES TO HOLD HATTRIX FREE
    FROM RESPONSIBILITY FOR ANY LIABILITY OR DAMAGE THAT MIGHT ARISE OUT OF END
    USER’S ACCESS TO OR INTERACTIONS WITH ANY OF ITS CUSTOMERS. HATTRIX IS NOT
    RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY CUSTOMER, AND
    WILL NOT BE LIABLE FOR ANY CLAIM, INJURY OR DAMAGE ARISING IN CONNECTION
    WITH ANY OTHER PARTY ENCOUNTERED ON THE PLATFORM INCLUDING ANY CUSTOMER. End
    User is solely responsible to any Customer for any opinions, advice, or
    information communicated. Any agreements entered into between End User and
    any party (including any Customer) are solely between the parties and
    Hattrix is not a party to such agreements. End User shall indemnify and
    hold harmless Hattrix from any claims related to any Customer in accordance
    with this Agreement. End User is solely responsible for resolving any
    issues with any Customer.
  </p>
  <ol start='9'>
    <li>
      <p lang='en-US'>
        <strong>Privacy Policy</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    We value your privacy and understand your privacy concerns. Our Privacy
    Policy is incorporated into this Agreement, and it governs your submission
    of information to our Platform. Please review our Privacy Policy so that you
    may understand our privacy practices. All information we collect is subject
    to our Privacy Policy, and by using the Platform you consent to all actions
    taken by us with respect to your information in compliance with the Privacy
    Policy.
  </p>
  <ol start='10'>
    <li>
      <p lang='en-US'>
        <strong>End User</strong> <strong>Content</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    An End User’s ability to submit or transmit any information through the
    Platform, including but not limited to End User information, Customer
    Communications, emails, recordings, written content, images, videos, or any
    other information will be referred to as “End User Content” throughout this
    Agreement. Hattrix is not required to host, store, display, migrate, or
    distribute any of your End User Content and we may refuse to accept or
    transmit any End User Content at our discretion. You agree that you are
    solely responsible for any End User Content submitted and you release us
    from any liability associated with any End User Content submitted. Any End
    User Content found to be in violation of this Agreement or that we determine
    to be harmful to the Platform may be modified, edited, or removed at our
    discretion.
  </p>
  <p lang='en-US'>
    When submitting any End User Content to our Platform you represent and
    warrant that you own all rights to the End User Content, you have paid any
    fees to use or license the End User Content, or you otherwise have the
    permission and right to use any End User Content. Furthermore, you represent
    and warrant that all End User Content is legal and the End User Content does
    not interfere with any third party rights or obligations.
  </p>
  <p lang='en-US'>
    When you submit any End User Content to us, you grant Hattrix, its partners,
    affiliates, End Users, representatives and assigns a non-exclusive,
    unlimited, fully-paid, royalty-free, irrevocable, world-wide, universal,
    transferable, assignable license to display, distribute, store, broadcast,
    transmit, reproduce, modify, prepare derivative works, or use and reuse all
    or part of your End User Content for such purposes as required by us
    including to provide you access to the services offered on the Platform.
    Hattrix has no liability to you for any End User Content including all data,
    information, copy, images, URL names, and anything else submitted by you or
    any third parties using the Platform. Specifically, Hattrix shall not be
    liable for any errors related to any End User Content. We reserve the right
    to remove, delete, modify, screen, edit, or refuse any End User Content for
    any reason or no reason, and with or without notice to you.
  </p>
  <ol start='11'>
    <li>
      <p lang='en-US'>
        <strong>Results Generated</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Hattrix is not responsible for any information or results generated via the
    Platform. End User understands and agrees that all results generated by the
    Platform are dependent on the information contained in any End User Content
    submitted by you and you are solely responsible for that information. THE
    END USER AGREES TO HOLD HATTRIX FREE FROM RESPONSIBILITY FOR ANY LIABILITY
    OR DAMAGE THAT MIGHT ARISE OUT OF YOUR USE OF THE PLATFORM OR RESULTS
    GENERATED. HATTRIX WILL NOT BE LIABLE FOR ANY CLAIM, INJURY OR DAMAGE
    ARISING IN CONNECTION WITH YOUR USE OF THE PLATFORM. Hattrix does not
    warrant any results, guarantee, endorse, or recommend any portion of the
    Platform and use of the Platform is at your own risk.
  </p>
  <ol start='12'>
    <li>
      <p lang='en-US'>
        <strong>Information Found on the Platform</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    ALL HATTRIX CONTENT FOUND ON THE PLATFORM IS FOR GENERAL INFORMATIONAL AND
    EDUCATIONAL PURPOSES ONLY. Hattrix does not endorse or warrant any Hattrix
    content (“Hattrix Content”), such as, encountered on the Platform including
    but not limited to any materials, recordings, manuals, documentation, or
    other information including any Underlying Technology. All Hattrix Content
    is offered “as-is” and without warranty of any kind. Please be aware that
    Hattrix Content may be inaccurate, untimely, or contain errors. You solely
    are responsible for your use of any Hattrix Content and you agree to release
    us from any liability related to your use of any Hattrix Content.
  </p>
  <ol start='13'>
    <li>
      <p lang='en-US'>
        <strong>Use of the Platform</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    When using our Platform, you are responsible for your use of the Platform.
    You agree to the following:
  </p>
  <ul>
    <li>
      You may not attempt to interfere with, compromise the system integrity
      or security, or decipher any transmissions to or from the servers
      running the Platform;
    </li>
    <li>
      <p lang='en-US'>
        You may not decompile, reverse engineer, disassemble, modify, rent,
        sell, lease, loan, distribute, or create derivative works or
        improvements to the Platform or any portion of it;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not access our Platform in an attempt to build a similar or
        other competitive product;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not use the Platform in an unlawful manner that violates the
        laws of your jurisdiction or the laws of the United States;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not take any action that imposes, or may impose at our sole
        discretion, an unreasonable or disproportionately large load on our
        infrastructure;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not violate or infringe other people's intellectual
        property, privacy, or other contractual rights while using our
        Platform;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not use the Platform in a manner that would cause liability
        or harm to Hattrix;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You may not interfere with or disrupt the Platform;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        You agree not to use the Platform in any way that is: misleading,
        unlawful, defamatory, obscene, invasive, threatening, or harassing;
        and
      </p>
    </li>
    <li>
      You agree that you will not hold Hattrix responsible for your use of our
      Platform
    </li>
  </ul>
  <p lang='en-US'>
    If you are discovered to be undertaking any of the aforementioned actions
    your privileges to use our Platform, may at our discretion, be terminated or
    suspended. Additionally, if we believe that your actions may harm us or a
    third party we may suspend or terminate your use of the Platform and we may
    pursue any legal remedy available to us under applicable law. Generally, we
    will provide an explanation for any suspension or termination of your use of
    any of our Platform, but Hattrix reserves the right to suspend or terminate
    any account at any time at our discretion.
  </p>
  <ol start='14'>
    <li>
      <p lang='en-US' style='text-align: justify;'>
        <strong>Equipment and Connections</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    In order to access the Platform, you may be required to purchase “Equipment”
    such as a computer or other device. You are solely responsible for
    purchasing and properly connecting such Equipment to access the Platform.
    Some portions of the Platform may provide real time notifications through
    the internet or telecommunications systems (“Connection(s)”) you are solely
    responsible for purchasing and maintaining such Connections. Please be aware
    that standard data, calling, and message rates apply. Please consult your
    Connection provider for a full list of fees and charges. Hattrix shall not
    be liable to you for any failure or issue related to any Connection or
    Equipment you may use to interact with the Platform.
  </p>
  <ol start='15'>
    <li>
      <p lang='en-US' style='text-align: justify;'>
        <strong>End User Account Holds</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    From time to time, Hattrix may freeze or place a hold (“Hold”) on an End
    User’s account. Some of the reasons that we may place a Hold on End User’s
    account include but are not limited to the following: (1) if we have reason
    that End User’s actions have violated this Agreement, may harm our business
    or another party, are deceptive, misleading, unlawful, or have harmed a
    third party or interfere with a third party contractual right; (2) at the
    request of our payment processors or due to delayed payment; or (3) if
    required in order to comply with a court order, subpoena, writ, injunction,
    or as otherwise required under applicable laws and regulations. If End User
    has questions about a Hold we may have placed on End User’s account, or need
    information about how to resolve the Hold, please contact us. Additionally,
    we may suspend End User’s access to the Platform while such Hold is in
    place.
  </p>
  <ol start='16'>
    <li>
      <p lang='en-US'>
        <strong>Platform Availability</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Although we strive to make the Platform generally available, we do not
    guarantee that the Platform will always be available, work, or be accessible
    at any particular time. Specifically, we do not guarantee any uptime or
    specific availability of the Platform. You agree and acknowledge that the
    Platform may not always be either 100% reliable or available. Only End Users
    who are eligible to use our Platform may do so and we may refuse service or
    terminate your access at any time. We cannot guarantee that anything found
    on our Platform will work to the functionality desired by you or give you
    any desired results.
  </p>
  <ol start='17'>
    <li>
      <p lang='en-US'>
        <strong>Modification of Platform</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    We reserve the right to alter, modify, update, or remove the Platform or any
    portions thereof, at any time at our discretion. We reserve the right to
    discontinue previously offered features or functionality at our sole
    discretion and without prior notice. We are not liable to you or to any
    third party for any modification, suspension, or discontinuance of any
    feature or component of any portion of the Platform. We reserve the right to
    determine the timing and content of software updates, which may be
    automatically downloaded and installed by the Platform without notice to
    you.
  </p>
  <ol start='18'>
    <li>
      <p lang='en-US'>
        <strong>Third Party Content and Websites</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Hattrix does not endorse or warrant any Third Party Content including but
    not limited to any materials, results, information, or other data provided
    by a third party (collectively “Third Party Content”) and does not assume
    responsibility for any Third Party Content encountered whether through the
    Platform or otherwise. If you use or access any Third Party Content you do
    so at your own risk. We recommend that you independently evaluate Third
    Party Content and you should not solely rely on the Third Party Content
    displayed on the Platform to make any decisions. If you require more
    information regarding any Third Party Content, please contact the owner of
    such Third Party Content. Further, Hattrix assumes no liability for
    inaccuracies or misstatements made by such third parties responsible for
    such Third Party Content.
  </p>
  <p lang='en-US' style='text-align: justify;'>
    Through the Platform End User may connect to third party software or
    websites (“Third Party Website(s)”). Where a Third Party Website is made
    available through the Platform, Hattrix does not warrant or endorse any such
    Third Party Websites. End User uses any Third Party Websites solely at their
    own risk. All such Third Party Websites are controlled by third parties and
    such third parties are solely responsible for any claims or offerings made
    available through such Third Party Websites. Any issues with the
    transmission, processing, or storage of any End User Content by any Third
    Party Websites is solely to be resolved by and between you and any entity
    owning such Third Party Websites. Hattrix will not be responsible for any
    connectivity issues related to any Third Party Websites and the Platform.
    End User’s access to any Third Party Websites are subject to the terms and
    conditions of the owner of such Third Party Websites and End User agrees
    that End User’s use of the Platform shall not violate any terms or
    conditions of such Third Party Websites.
  </p>
  <ol start='19'>
    <li>
      <p lang='en-US'>
        <strong>Idea Submission</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Hattrix or any of its employees do not accept or consider unsolicited ideas,
    including but not limited to ideas relating to processes, technologies,
    product enhancements, or product names. Please do not submit any unsolicited
    ideas, content, artwork, suggestions, or other works (“Submissions”) in any
    form to Hattrix. The sole purpose of this policy is to avoid potential
    misunderstandings or disputes when Hattrix’ products might seem similar to
    ideas submitted to Hattrix. Any Submissions, whether solicited or
    unsolicited, will be treated as follows: (1) Submissions and their contents
    will automatically become the property of Hattrix, without any compensation
    to the submitter; (2) Hattrix may use or redistribute the Submissions and
    their contents for any purpose and in any way; (3) there is no obligation
    for Hattrix to review the Submission; and (4) there is no obligation to keep
    any Submissions confidential.
  </p>
  <ol start='20'>
    <li>
      <p lang='en-US'>
        <strong>Disclaimer</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    THE PLATFORM IS PROVIDED ON AN "AS IS", "AS AVAILABLE" AND "WITH ALL FAULTS"
    BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, NEITHER HATTRIX, NOR ANY OF
    OUR EMPLOYEES, DIRECTORS, OFFICERS, ASSIGNS, AFFILIATES, OR AGENTS MAKE ANY
    REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO: (1) THE PLATFORM OR ANY
    ASSOCIATED SERVICES; (2) ANY INFORMATION OR CONTENT PROVIDED VIA THE
    PLATFORM INCLUDING ANY CONFIDENTIALITY THEREOF; (3) THE NATURE OR FIDELITY
    OF ANY DOWNLOADED INFORMATION INCLUDING CONSUMER COMMUNICATIONS WILL BE FREE
    OF VIRUSES, WORMS <strong>,</strong> TROJAN HORSES OR OTHER DESTRUCTIVE
    PROGRAMMING; OR (4) SECURITY ASSOCIATED WITH THE TRANSMISSION OF INFORMATION
    TO OR FROM THE PLATFORM. IN ADDITION, WE DISCLAIM ALL WARRANTIES, EXPRESS OR
    IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, TITLE, CUSTOM, TRADE,
    QUIET ENJOYMENT, SYSTEM INTEGRATION, AND FREEDOM FROM COMPUTER VIRUS.
    HATTRIX DOES NOT REPRESENT OR WARRANT THAT THE PLATFORM WILL BE ERROR-FREE
    OR UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE PLATFORM OR
    THE SERVER THAT MAKES THE PLATFORM AVAILABLE IS FREE FROM ANY HARMFUL
    COMPONENTS. HATTRIX DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE
    INFORMATION (INCLUDING ANY INSTRUCTIONS) ON THE PLATFORM IS ACCURATE,
    COMPLETE, OR USEFUL. HATTRIX DOES NOT WARRANT THAT YOUR USE OF THE PLATFORM
    IS LAWFUL IN ANY PARTICULAR JURISDICTION, AND HATTRIX SPECIFICALLY DISCLAIMS
    ANY SUCH WARRANTIES.
  </p>
  <ol start='21'>
    <li>
      <p lang='en-US'>
        <strong>Limitation of Liability</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    IN NO EVENT SHALL HATTRIX, ITS OFFICERS, DIRECTORS, EMPLOYEES, AFFILIATES,
    OR AGENTS, BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE,
    OR CONSEQUENTIAL DAMAGES, WHETHER BASED ON WARRANTY, CONTRACT, TORT
    (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, WHETHER OR NOT HATTRIX IS
    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATION OF
    LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE
    APPLICABLE JURISDICTION. SOME STATES DO NOT ALLOW THE LIMITATION OR
    EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE
    LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. YOU MAY ALSO HAVE OTHER LEGAL
    RIGHTS THAT VARY FROM STATE TO STATE. SPECIFICALLY, IN THOSE JURISDICTIONS
    NOT ALLOWED, WE DO NOT DISCLAIM LIABILITY FOR: (1) DEATH OR PERSONAL INJURY
    CAUSED BY HATTRIX’S NEGLIGENCE OR THAT OF ANY OF ITS OFFICERS, EMPLOYEES OR
    AGENTS; (2) FRAUDULENT MISREPRESENTATION; OR (3) ANY LIABILITY WHICH IT IS
    NOT LAWFUL TO EXCLUDE EITHER NOW OR IN THE FUTURE. WHERE A TOTAL DISCLAIMER
    OF LIABILITY IS DISALLOWED, YOU AGREE THAT OUR TOTAL LIABILITY TO YOU SHALL
    NOT EXCEED THE AMOUNTS YOU HAVE PAID IN THE PAST SIX (6) MONTHS TO USE OUR
    PLATFORM OR TEN THOUSAND UNITED STATES’ DOLLARS, WHICHEVER IS LESSER.
  </p>
  <ol start='22'>
    <li>
      <p lang='en-US'>
        <strong>Indemnity</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    You agree to defend, indemnify and hold harmless Hattrix, its officers,
    directors, employees, affiliates, and agents, from and against any and all
    claims, damages, obligations, losses, liabilities, costs or debt, and
    expenses (including but not limited to attorney's fees) arising from:
  </p>
  <ul>
    <li>
      <p lang='en-US'>
        Your or your authorized End User’s use of and access to the Hattrix
        Platform or any associated services including but not limited to any
        End User Content or Consumer Communications;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        Your or your authorized End User’s violation of any term of this
        Agreement;
      </p>
    </li>
    <li>
      <p lang='en-US'>
        Your or your authorized End User’s violation of any third party
        right, including without limitation any copyright, property,
        Customer right, or contractual right.
      </p>
    </li>
  </ul>
  <p lang='en-US'>
    This defense and indemnification obligation will survive this Agreement and
    your use of the Hattrix Platform. You also agree that you have a duty to
    defend us against such claims and we may require you to pay for an
    attorney(s) of our choice in such cases. You agree that this indemnity
    extends to requiring you to pay for our reasonable attorneys’ fees, court
    costs, and disbursements. In the event of a claim such as one described in
    this paragraph, we may elect to settle with the party/parties making the
    claim and you shall be liable for the damages as though we had proceeded
    with a trial.
  </p>
  <ol start='23'>
    <li>
      <p lang='en-US'>
        <strong>Copyrights</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    <u>Takedown Notice</u>
  </p>
  <p lang='en-US'>
    We take copyright infringement very seriously. If you believe that any
    copyrighted material owned by you has been infringed upon by someone using
    our Platform, please send us a message which contains:
  </p>
  <ul>
    <li>
      <p lang='en-US'>
        Your name.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        The name of the party whose copyright has been infringed, if
        different from your name.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        The name and description of the work that is being infringed.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        The location on our Platform of the infringing copy.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        A statement that you have a good faith belief that use of the
        copyrighted work described above is not authorized by the copyright
        owner (or by a third party who is legally entitled to do so on
        behalf of the copyright owner) and is not otherwise permitted by
        law.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        A statement that you swear, under penalty of perjury, that the
        information contained in this notification is accurate and that you
        are the copyright owner or have an exclusive right in law to bring
        infringement proceedings with respect to its use.
      </p>
    </li>
  </ul>
  <p lang='en-US'>
    You must sign this notification and send it to our Copyright Agent:
    Copyright Agent of Hattrix,
    <a href='mailto:admin@retreva.com'>
      admin@retreva.com
    </a>
    or Hattrix, LLC, 3767 Attucks Dr., Powell, OH 43065
  </p>
  <p lang='en-US'>
    <u>Counter Notice</u>
  </p>
  <p lang='en-US'>
    In the event that you receive a notification from Hattrix stating content
    posted by you has been subject to a DMCA takedown, you may respond by filing
    a counter-notice pursuant to the DMCA. Your counter-notice must contain the
    following:
  </p>
  <ul>
    <li>
      <p lang='en-US'>
        Your name, address, email and physical or electronic signature.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        The notification reference number (if applicable).
      </p>
    </li>
    <li>
      <p lang='en-US'>
        Identification of the material and its location before it was
        removed.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        A statement under penalty of perjury that the material was removed
        by mistake or misidentification.
      </p>
    </li>
    <li>
      <p lang='en-US'>
        Your consent to the jurisdiction of a federal court in the district
        where you live (if you are in the U.S.), or your consent to the
        jurisdiction of a federal court in the district where your service
        provider is located (if you are not in the US).
      </p>
    </li>
    <li>
      <p lang='en-US'>
        Your consent to accept service of process from the party who
        submitted the takedown notice.
      </p>
    </li>
  </ul>
  <p lang='en-US'>
    Please be aware that we may not take any action regarding your
    counter-notice unless your notification strictly complies with the foregoing
    requirements. Please send this counter-notice to:
    <a href='mailto:admin@retreva.com'>
      admin@retreva.com
    </a>
    or Hattrix, LLC, 3767 Attucks Dr., Powell, OH 43065
  </p>
  <ol start='24'>
    <li>
      <p lang='en-US'>
        <strong>Choice of Law</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    This Agreement shall be governed by the laws in force in the state of Ohio.
    The offer and acceptance of this contract is deemed to have occurred in
    Ohio. The United Nations Convention on Contracts for the International Sale
    of Goods will not apply to this Agreement and is hereby expressly excluded.
  </p>
  <ol start='25'>
    <li>
      <p lang='en-US'>
        <strong>Disputes</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    This Agreement and any dispute arising out of or in connection with this
    Agreement (“Dispute”) shall be subject to arbitration as set forth.
  </p>
  <p>
    <u>Binding Arbitration</u>
  </p>
  <p lang='en-US'>
    You agree that any dispute relating in any way to your use of the Platform
    shall be submitted to confidential binding arbitration. If there is a
    dispute about whether this arbitration provision can be enforced or applies
    to the Dispute, you and Hattrix agree that the arbitrator will decide that
    issue. However, any claim that all or part of this Class Action Waiver is
    unenforceable, unconscionable, void or voidable may be determined only by a
    court of competent jurisdiction and not by an arbitrator.
  </p>
  <p lang='en-US'>
    Arbitration under this Agreement is under the Federal Arbitration Act which
    governs the interpretation and enforcement of this provision. The
    arbitration will be administered by American Arbitration Association in
    accordance with their Commercial Arbitration Rules (the “Rules”) then in
    effect, found at https://www.aaa.com Arbitration shall be conducted by one
    (1) arbitrator as selected pursuant to the Rules; the arbitrator's award
    shall be final and binding and may be entered as a judgment in any court of
    competent jurisdiction. The location of the arbitration shall be in
    Columbus, OH. Each party shall be responsible for their own arbitration fees
    and costs. To the fullest extent permitted by applicable law, no arbitration
    under this Agreement shall be joined to an arbitration involving any other
    party subject to this Agreement, whether through class action proceedings or
    otherwise. You agree that regardless of any statute or law to the contrary,
    any claim or cause of action arising out of, related to or connected with
    the use of the Platform or this Agreement must be filed within one (1) year
    after such claim or cause of action arose or be forever banned. In the event
    that the law does not permit the abovementioned dispute to be resolved
    through arbitration, you agree that any actions shall be brought solely in a
    court of competent jurisdiction located within Franklin County, OH. This
    arbitration provision shall not apply to any claims requiring injunctive
    relief or regarding intellectual property or confidentiality rights, such
    claims shall be heard in a court of competent jurisdiction located within
    Franklin County, OH.
  </p>
  <p lang='en-US'>
    You have the right to opt out of binding arbitration within thirty (30) days
    of the date You first accepted this Agreement by notifying us via mail at
    Hattrix, LLC, 3767 Attucks Dr., Powell, OH 43065. In order to be effective,
    the opt out notice must include your full name, any account information, and
    must clearly indicate your intent to opt out of binding arbitration. If you
    have decided to opt-out of Binding Arbitration, all Disputes shall be heard
    in a court of competent jurisdiction located within Franklin County, OH.
  </p>
  <ol start='26'>
    <li>
      <p lang='en-US'>
        <strong>Class Action and PAGA Waiver</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    You and Hattrix agree that any proceedings to resolve or litigate any
    dispute whether through a court of law or arbitration shall be solely
    conducted on an individual basis. You agree that you will not seek to have
    any dispute heard as a class action, representative action, collective
    action, or private attorney general action. You agree to waive any right to
    a trial by jury.
  </p>
  <ol start='27'>
    <li>
      <p lang='en-US'>
        <strong>Severability</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    In the event that a provision of this Agreement is found to be unlawful,
    conflicting with another provision of the Agreement, or otherwise
    unenforceable, the Agreement will remain in force as though it had been
    entered into without that unenforceable provision being included in it.
  </p>
  <p lang='en-US'>
    If two or more provisions of this Agreement or any other agreement you may
    have with Hattrix are deemed to conflict with each other’s operation,
    Hattrix shall have the sole right to elect which provision remains in force.
  </p>
  <ol start='28'>
    <li>
      <p lang='en-US'>
        <strong>Non-Waiver</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    We reserve all rights permitted to us under this Agreement as well as under
    the provisions of any applicable law. Our non-enforcement of any particular
    provision or provisions of this Agreement or any applicable law should not
    be construed as our waiver of the right to enforce that same provision under
    the same or different circumstances at any time in the future.
  </p>
  <ol start='29'>
    <li>
      <p lang='en-US'>
        <strong>Assignment and Survival</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    You may not assign your rights and/or obligations under this Agreement to
    any other party without our prior written consent. We may assign our rights
    and/or obligations under this Agreement to any other party at our
    discretion. All portions of this Agreement that would reasonably be believed
    to survive termination shall survive and remain in full force upon
    termination, including but not limited to the Limitation of Liabilities,
    Disclaimer, End User Content, Access, Payment, Indemnification, Class
    Action, and Arbitration sections.
  </p>
  <ol start='30'>
    <li>
      <p lang='en-US'>
        <strong>Entire Agreement and Notices</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    This Agreement along with the Privacy Policy constitute the complete and
    exclusive understanding and agreement between the parties regarding the
    subject matter herein and supersede all prior or contemporaneous agreements
    or understandings written or oral, relating to its subject matter. Where
    this Agreement expressly and directly conflicts with the Privacy Policy,
    this Agreement shall control. Any waiver, modification or amendment of any
    provision of this Agreement will be effective only if in writing and signed
    by a duly authorized representative of each party. Any notices required
    under this Agreement shall be delivered to Hattrix, LLC, 3767 Attucks Dr.,
    Powell, OH 43065, delivery confirmation required. Any notices to End User
    shall be delivered either electronically via email or to the End User’s
    address listed within the Platform.
  </p>
  <ol start='31'>
    <li>
      <p lang='en-US'>
        <strong>Amendments</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    We may amend this Agreement from time to time. When we amend this Agreement,
    we will update this page and indicate the date that it was last modified or
    we may email you. You may refuse to agree to the amendments, but if you do,
    you must immediately cease using our Platform and please delete your account
    through your account page.
  </p>
  <ol start='32'>
    <li>
      <p lang='en-US' style='text-align: justify;'>
        <strong>Electronic Communications</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    The communications between you and Hattrix use electronic means, whether you
    visit the Platform or send Hattrix e-mails, or whether Hattrix posts notices
    on the Platform or communications with you via mobile notifications or
    e-mail. For contractual purposes, you (1) consent to receive communications
    from Hattrix in an electronic form; and (2) agree that all terms,
    conditions, agreements, notices, disclosures, and other communications that
    Hattrix provides to you electronically satisfy any legal requirement that
    such communications would satisfy if it were to be in writing. The foregoing
    does not affect your statutory rights.
  </p>
  <ol start='33'>
    <li>
      <p lang='en-US' style='text-align: justify;'>
        <strong>Platform Issues</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    If you have any questions, issues, or have trouble accessing or using the
    Platform, please contact us through the Platform by email at
    <u><a href='mailto:help@retreva.com'>help@retreva.com</a></u>.
  </p>
  <ol start='34'>
    <li>
      <p lang='en-US' style='text-align: justify;'>
        <strong>Termination</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    We may terminate this Agreement, if: (1) you have violated any applicable
    laws while using our Platform; (2) if you have violated any portion of this
    Agreement or any of our Platform policies; or (3) if we believe that any of
    your current or future actions may legally harm Hattrix, our business
    interests or a third party, at our discretion. In the event of account
    termination, we will strive to provide you with a timely explanation;
    however, we are not required to do so. Please be aware that upon termination
    of your account, access to all or portions of our Platform may become
    immediately disabled and any End User Content stored on the Platform may
    become inaccessible or deleted and we shall have no liability to you in
    regards to any retention of your End User Content.
  </p>
  <ol start='35'>
    <li>
      <p>
        <strong>Payments for Subscriptions</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Any End User purchasing a Subscription shall be referred to as a
    “Subscriber”. Subscriber agrees to pay for all costs, fees, and taxes listed
    when purchasing any Subscription to the Platform or for any additional
    purchases. Some portions of the Subscription are billed on a per email basis
    please be aware that Subscriber is solely responsible for limiting any
    charges on a per email basis and such limiting may be done through
    Subscriber’s account. Subscriber authorizes Hattrix or its third party
    payment processors to charge their method of payment on file at the time of
    purchase. Where applicable, you must agree to our third party payment
    processors terms and conditions for processing payments. All prices are
    listed in US Dollars. All information that you provide in connection with a
    purchase or transaction must be accurate, complete, and current. Where you
    have failed to pay or where payments are overdue, Hattrix may suspend or
    terminate your access to the paid portions of the Platform, without
    liability to us.
  </p>
  <ol start='36'>
    <li>
      <p>
        <strong>Free Trials</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US' style='text-align: justify;'>
    Hattrix may offer the Platform on a free trial basis. Hattrix reserves the
    right to discontinue or modify any free trials at any time and without
    liability. Where Subscriber has signed up for a free trial, Subscriber
    agrees that at the expiration of Subscriber’s free trial Subscriber may be
    automatically charged for any additional usage of the Platform in accordance
    with Hattrix’s then current pricing.
  </p>
  <ol start='37'>
    <li>
      <p>
        <strong>Refunds</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Please be aware that no refunds are available for any paid Subscriptions. If
    you feel that you may be entitled to a refund please contact us.
  </p>
  <ol start='38'>
    <li>
      <p>
        <strong>Taxes</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Where Hattrix does not charge you taxes for any Subscriptions, you agree to
    pay any and all applicable taxes.
  </p>
  <ol start='39'>
    <li>
      <p>
        <strong>Subscription Plans and Renewals</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    In order to access certain functionality within the Platform, you may be
    required to purchase a Subscription. Please be aware that multiple
    Subscriptions may be required where applicable. Where you purchase a
    Subscription, your payment information shall be logged for your convenience.
    IF YOUR ACCOUNT HAS BEEN SET UP FOR AUTOMATIC PAYMENTS, HATTRIX MAY CHARGE
    YOU AUTOMATICALLY AND ON A RECURRING BASIS, UNLESS YOU NOTIFY US THAT YOU
    WANT TO CANCEL YOUR AUTOMATIC PAYMENT VIA YOUR ACCOUNT DASHBOARD.
    ADDITIONALLY, YOU AUTHORIZE US TO BILL YOU ON A RECURRING BASIS AND AGREE
    THAT YOUR SELECTED SUBSCRIPTION SHALL AUTOMATICALLY RENEW FOR ADDITIONAL
    PERIODS (OF THE SAME LENGTH AS YOUR INITIAL SUBSCRIPTION) UNTIL WE ARE
    NOTIFIED OTHERWISE. YOU AGREE THAT NO ADDITIONAL CONSENT IS REQUIRED BY YOU
    TO CHARGE YOUR PREFERRED PAYMENT METHOD AUTOMATICALLY AND ON AN
    AUTOMATICALLY RENEWABLE BASIS FOR THE SUBSCRIPTION SELECTED. Please be aware
    that you are able to cancel your Subscription prior to purchase or at any
    time by canceling via your Platform account dashboard or by contacting us
    via the Platform.
  </p>
  <ol start='40'>
    <li>
      <p>
        <strong>Pricing and Price Increases</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    The pricing for all paid Subscriptions is listed on the Hattrix Platform or
    within your account. Hattrix may increase the price of any paid
    Subscriptions, at our discretion and we reserve the right to do so at any
    time. In the event of a price increase, Hattrix shall notify you and you
    will have the chance to accept or reject any price increase before the paid
    Subscription renewal. Generally, we may notify you of any price increases.
    Upon receipt of such notice, please notify us if you intend to reject a
    price increase. Where you have rejected a price increase, upon the
    expiration of your paid Subscription, portions of the Platform may become
    immediately unavailable. You agree that Hattrix has no obligation to offer
    any Subscriptions for the price originally offered to you at sign up.
  </p>
  <ol start='41'>
    <li>
      <p style='text-align: justify;'>
        <strong>Support</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    Where Subscriber requires support related to its Subscription, please
    contact us at <a href='mailto:help@retreva.com'>help@retreva.com</a>.
  </p>
  <ol start='42'>
    <li>
      <p style='text-align: justify;'>
        <strong>Termination of Your Subscription</strong>
      </p>
    </li>
  </ol>
  <p lang='en-US'>
    You may cancel your Hattrix Subscription at any time. In order to avoid
    being charged for an additional Subscription period you must cancel your
    Subscription prior to your Subscription renewal date. You may cancel any
    time via your Hattrix dashboard or by contacting us via the Platform. Please
    be aware that upon cancellation of your Subscription you will continue to
    have access until the conclusion of your current Subscription period. After
    the conclusion of your current Subscription period, access to portions of
    our Platform may become immediately disabled and some End User Content may
    become immediately inaccessible, deleted, or removed. Where you have
    canceled your Subscription, we have no responsibility to you for any losses
    incurred by you for your inability to access portions of Platform or any End
    User Content stored in such portions of the Platform.
  </p>
</div>